module.exports = __webpack_public_path__ + "static/media/testTube.23ce665c.svg";